export const NAME = 'name';
export const DESCRIPTION = 'description';
export const PRICE_TYPE = 'priceType';
export const VISIBLE = 'visible';
export const VIDEO_CONFERENCE = 'videoconference';
export const IN_PERSON_MEETING = 'inPersonMeeting';
export const AUDIO = 'audio';
export const SPECIFIC_TIME = 'specificTime';
export const LIMIT = 'limit';
export const RATE = 'rate';
export const ENABLED_WAITLIST = 'enabledWaitlist';
export const WAITLIST_SIZE = 'waitlistSize';
export const DURATION = 'durationInMins';
export const AUDIO_PREMIUM_FEE = 'audioPremiumFee';
export const FLAT_RATE = 'flatRate';
export const VIDEO_PREMIUM_FEE = 'videoPremiumFee';
export const IN_PERSON_PREMIUM_FEE = 'inPersonPremiumFee';
export const SELECTED_IN_PERSON_MEETING_LOCATION = 'selectedInPersonMeetingLocation';
export const IN_PERSON_MEETING_LOCATION_ID = 'inPersonMeetingLocationId';
export const SESSIONS_COST = 'sessionsCost';
export const DISCOUNT_PERCENTAGE = 'discountPercentage';
export const CALL_VIA = 'callVia';
export const PASSCODES = 'passcodes';
export const PASSCODE = 'passcode';
export const TEMPLATE_ID = 'templateId';
export const CHARITY = 'charity';
export const CHARITY_ID = 'charityId';
export const CHARITY_NAME = 'charityName';
export const CHARITY_PERCENTAGE = 'charityPercentage';
export const CHARITY_MESSAGE_VISIBLE = 'charityMessageVisible';

export const YES = 'true';
export const NO = 'false';
export const FIXED = 'fixed';
export const CUSTOM = 'custom';
export const CALL_VIA_ALL_METHODS = 'all_methods';
export const CALL_VIA_SYSTEM = 'system';
export const CALL_VIA_ZOOM = 'zoom';

export const ZOOM_MEETING_SETTINGS = 'zoomMeetingSettings';

export const CHECKLIST_TASKS = 'checklistTasksAttributes';
export const ACTIVE_CHECKLIST_TASKS = 'activeChecklistTasks';
export const DESTROYED_CHECKLIST_TASKS = 'destroyedChecklistTasks';

export const SURVEY_SCHEMA = 'surveySchema';
export const SURVEY_TIMING = 'surveyTiming';
export const CHECKLIST_TIMING = 'checklistTiming';
export const SURVEY_LOCKED = 'surveyLocked';
export const TIMING_LOCKED = 'timingLocked';

export const BEFORE_SESSION = 'before_session';
export const AFTER_SESSION = 'after_session';

export const EMPTY_SURVEY_SCHEMA = { pages: [{ name: 'page1', elements: [] }] };

export const TOTAL = 'total';
export const CALL_LENGTH = 'callLength';
export const COMMUNICATE_VIA = 'communicateVia';
export const PROPOSED_TIMES = 'proposedTimes';

export const TOTAL_COST_RANGE = 'totalCostRange';

export const MINIMUM_PRICE_PER_MINUTE = 0.5;

export const CHECKLIST_REQUIRED_RESPONSE_TYPES = {
  yes: {
    value: 'true',
    label: 'Yes',
  },
  no: {
    value: 'false',
    label: 'No',
  },
};

export const CHECKLIST_RESPONSE_INPUT_TYPES = {
  multipleLines: {
    value: 'text_area',
    label: 'Multiple lines',
  },
  singleLine: {
    value: 'text',
    label: 'Single line',
  },
};

export const DEFAULT_CHECKLIST_TASK = {
  name: '',
  requiredResponse: CHECKLIST_REQUIRED_RESPONSE_TYPES.yes.value,
  responseInputType: CHECKLIST_RESPONSE_INPUT_TYPES.multipleLines.value,
};

export const COMMUNICATION_PREFRENECES = {
  audio: 'audio',
  videoconference: 'videoconference',
  inPerson: 'in_person_meeting',
};

export const PRICE_TYPES = {
  fixed: FIXED,
  custom: CUSTOM,
};

export const PERMITTED_CALL_REQUEST_ATTRIBUTES = [
  'tag',
  'message',
  'link',
  'discountCode',
  'communicateVia',
  'callTypeId',
  'durationInMins',
  'walletId',
  'missedCallRequestId',
];
